import { render, staticRenderFns } from "./TrustEmailDashboardEcta.vue?vue&type=template&id=2071b09c&scoped=true"
import script from "./TrustEmailDashboardEcta.vue?vue&type=script&lang=js"
export * from "./TrustEmailDashboardEcta.vue?vue&type=script&lang=js"
import style0 from "./TrustEmailDashboardEcta.vue?vue&type=style&index=0&id=2071b09c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2071b09c",
  null
  
)

export default component.exports